import React, {Component} from 'react';
import {connect} from 'react-redux';
import { IWall } from '../core/models/wall';
import {Paper, Grid, withStyles, Container, Typography, IconButton, Tooltip} from '@material-ui/core';
import {Dispatch} from 'redux';
import {  REQUEST_POSTS} from '../core/handlers.actions';
import { IPost } from '../core/models/post';
import AddEditPostCard from './card/new.post';
import AddSharpIcon from '@material-ui/icons/AddSharp';
import DnDList from './drag.drop.list';
import {withRouter} from 'react-router-dom';
import PostTable from './table/wall.posts';
import WallPost from './card/index';

const styles = (theme:any) => ({
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        flexGrow: 1,
        position: 'relative' as any
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center' as any,
        color: theme.palette.text.secondary,
    },
    title: {
        marginBottom: theme.spacing(5)
    },
    addButton: {
        position: 'absolute' as any,
        top: '6rem',
        left: '1%',
        backgroundColor: '#490e6f',
        '&:hover': {
            backgroundColor:'#490e6f',
            opacity: '.5'
        }      
    },
    addIcon: {
        fontSize: '35px',
        color: '#ffffff'
    }
});

interface Props {
    walls:any;
    match:any;
    classes:any;
    posts: any;
    getPostsByTags: (postTags:any) => void; 
}

interface State {
    post:IPost | null;
    addingPost:boolean;
    editPostId: string | null;
    wall:any;
    postsLoaded: boolean;
}

class Wall extends Component <Props, State>{
    state:State = {wall:{featuredPosts:[]},  post:null, addingPost:false, editPostId: null, postsLoaded:false}; 
    
    constructor(props:Props){
        super(props);
        this.addPostHandler = this.addPostHandler.bind(this);
        this.postEditHandler = this.postEditHandler.bind(this);
        this.postCloseEditHandler = this.postCloseEditHandler.bind(this);
        this.updateLayout = this.updateLayout.bind(this);
        this.setWall = this.setWall.bind(this);      
        this.filterFeaturedPosts = this.filterFeaturedPosts.bind(this);
        this.renderHtml = this.renderHtml.bind(this);
        
    }

    componentDidMount(){
        const {walls} = this.props;
        this.setWall(walls);
    }
  
    public renderHtml(data:any) {
        return {__html: data};
    }

    public setWall(walls:any){
        const {match, getPostsByTags} = this.props;
        const {id} = match.params || false;
        if(!id) return 'No wall to set';
        const wall = walls.find((wall:IWall) => wall._id === id);
        const tags = wall.feedTagsRef.length > 0 ? {tags: wall.feedTagsRef.map((item: any) => item._id), version: 2}: {tags: wall.feedTags, version: 1};
        this.setState({...this.state, wall: wall});    
        getPostsByTags(tags);       
    }

    public addPostHandler(){
        this.setState({...this.state, addingPost: !this.state.addingPost});
    }

    public postEditHandler(item:any){
        const {_id} = item;        
        this.setState({...this.state, editPostId: _id, post: item});
        setTimeout(() => {
            document.querySelector('.main-post-container')?.scrollIntoView({ behavior: 'smooth' });
        }, 300);
    }

    public postCloseEditHandler(){
        this.setState({...this.state, editPostId: null, post:null});  
    }

    public updateLayout(){}

    public filterFeaturedPosts(posts:any, featuredlist:any, index:number, result?:any):any{
        if(featuredlist.length === index) return result;
        if(!result) result = [];
        const item = featuredlist[index];        
        const post = posts.find((element:IPost) => element._id === item.id) || false;        
        if(!post) return this.filterFeaturedPosts(posts, featuredlist, index + 1,result);
        post['featuredMeta'] = item;
        result.push(post);        
        return this.filterFeaturedPosts(posts, featuredlist, index + 1,result);
    }

    public render(){
        const {classes, posts, walls, match} = this.props;
        const { addingPost, editPostId, post} = this.state;
        const wall = walls.find((wall:IWall) => wall._id === match.params.id);
        const featuredPostList = (wall.featuredPosts.length > 0 && posts.length > 0) ? this.filterFeaturedPosts(posts, wall.featuredPosts, 0): null; // filter for the featured section        
       
        
        return(
            <Container maxWidth="lg" className={classes.container + ' main-post-container'}>
                <Grid container spacing={3} className={classes.title}>
                    <Grid item xs={12}>
                        <Paper className={classes.paper}>
                            <Typography variant="h2" dangerouslySetInnerHTML={this.renderHtml(wall.title)} />
                        </Paper>
                    </Grid>                    
                </Grid>   
                <Grid container spacing={3}>
                    <Grid item xs={9}>
                        {editPostId?
                            <Grid container spacing={3}>
                                <Grid item md={4}>
                                    <h2>Preview</h2> 
                                    <WallPost wallId={wall?._id} updateLayout={this.updateLayout} post={post} layoutType={post?.layout} editPostId={null} editPostAction={this.postEditHandler} closeAction={this.postCloseEditHandler}/>
                                </Grid>
                                <Grid item md={8}>
                                    <h2>Edit</h2>     
                                    <AddEditPostCard tags={post?.tags} post={post} action={this.postCloseEditHandler} edit={true} featuredTag={post?.featuredTag} tagsRef={post?.tagsRef}/>
                                </Grid>                                
                            </Grid>
                        :null}                       
                        {addingPost ?( <Grid item md={4} style={{position: 'relative'}}><AddEditPostCard tags={wall.wallTags} action={this.addPostHandler} edit={false} post={null} featuredTag={wall.postFeaturedTag} tagsRef={wall.wallTagsRef}/></Grid>):null}
                        <br />
                        <br />
                        <PostTable wallId={wall._id}  editPost={this.postEditHandler}/>
                    </Grid>
                    <Grid item xs={3}>
                        { featuredPostList ? 
                            <div>
                                <h2>Featured Posts</h2> 
                                <DnDList posts={featuredPostList} wallId={wall?._id}/> 
                            </div>
                        :
                        <h4>No featured posts have been set.</h4>
                        }
                    </Grid>
                </Grid>           
                
                {!addingPost?(<Tooltip title="Add Post"><IconButton onClick={this.addPostHandler} className={classes.addButton}>
                    <AddSharpIcon className={classes.addIcon} />
                </IconButton></Tooltip> ):null}                       
            </Container>
        );
    }
}

const props = (app:any) => ({walls: app.rootReducer.walls, posts: app.rootReducer.posts});
const dispatch = (dispatch:Dispatch) => ({
    getPostsByTags: (postTags:any) => dispatch({type: REQUEST_POSTS, payload: postTags})
});
export default withRouter(connect(props, dispatch)(withStyles(styles)(Wall)));